import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import type { RootState } from '../../../../configuration/setup/store';
import { getContracts } from '../../common/termedLevel/redux/termedLevelRenewal.redux';
import { OverlayTrigger, Tooltip } from '../../common/utils/tooltipReExports';
import { DEFAULT_TOOLTIP_DELAY } from '../../config/config';
import { getSelectedContracts } from './redux/contract.redux';

interface Props {
    productId: string;
    isDisabled: boolean;
}

const onCancelFreeContracts = () => undefined;

export const CancelFreeContractsButton = ({ isDisabled }: Props) => {
    const button = (
        <Button
            className='btn btn-primary margin-right-15'
            onClick={onCancelFreeContracts}
            disabled={isDisabled}
            style={isDisabled ? { pointerEvents: 'none' } : undefined}
            type='button'
            autoTrackingKey='marketplace.contracts.button.cancelFreeContracts'
        >
            <FormattedMessage id='marketplace.contracts.button.cancelFreeContracts' />
        </Button>
    );

    if (!isDisabled) {
        return button;
    }

    return (
        <OverlayTrigger
            trigger={OverlayTrigger.TRIGGER_HOVER}
            placement='top'
            overlay={
                <Tooltip id='cancel-free-contracts-tooltip'>
                    <FormattedMessage id='marketplace.contracts.tooltip.cancelFreeContracts' />
                </Tooltip>
            }
            delay={DEFAULT_TOOLTIP_DELAY}
        >
            <span className='d-inline-block'>{button}</span>
        </OverlayTrigger>
    );
};

const mapStateToProps = (state: RootState, ownProps: Pick<Props, 'productId'>) => {
    const selectedContracts = getSelectedContracts(state).filter(contract => contract.productId === ownProps.productId);

    const contractsByResourceId = new Map(
        getContracts(state)
            .filter(contract => contract.productId === ownProps.productId)
            .map(contract => [contract.resourceId, contract])
    );

    const hasNonFreeContractSelected = selectedContracts.some(
        selectedContract => contractsByResourceId.get(selectedContract.resourceId)?.paid !== false
    );

    return {
        isDisabled: selectedContracts.length === 0 || hasNonFreeContractSelected,
    };
};

export const CancelFreeContractsButtonContainer = connect(mapStateToProps)(CancelFreeContractsButton);
